import { render, staticRenderFns } from "./leaveIntership_formdialog.vue?vue&type=template&id=2bff21c2"
import script from "./leaveIntership_formdialog.vue?vue&type=script&lang=js"
export * from "./leaveIntership_formdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports